
define('text!templates/modules/template/edit/template-content.html',[],function () { return '<div class="last-saved-at"></div>\n<ul class="menu-actions nav nav-pills"></ul>\n<div class="template-form"></div>\n\n<div class="calendar-component"></div>\n';});

